function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { Button, Dialog, useId, useToasts } from '@applyboard/crystal-ui';
import { useState } from 'react';
import { useEventTracker, useTrackViewEvent, useQueryClient } from '@applyboard/ui-utils';
import { ApplicationActionName } from "../../../../types";
import { useIntakes, IntakeStatus, useApplicationAvailableActions, ProgramType, useCurrentInsightScoreToDisplay, useLegacyApplication, useUpdateApplication } from "../../data";
import { assert } from "../../../../utils/assert";
import { IntakesForm } from "../IntakesForm";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function ChangeIntakeModal(_ref) {
  var _getApplicationAvaila, _displayedScore$seatA, _displayedScore$seatA2;
  var _ref$buttonIntent = _ref.buttonIntent,
    buttonIntent = _ref$buttonIntent === void 0 ? 'primary' : _ref$buttonIntent,
    hideDialogTrigger = _ref.hideDialogTrigger,
    _onOpenChange = _ref.onOpenChange,
    isOpenViaProp = _ref.isOpenViaProp,
    origin = _ref.origin,
    onClick = _ref.onClick,
    _onSuccess = _ref.onSuccess,
    width = _ref.width;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsModalOpen = _useState2[1];
  var _useLegacyApplication = useLegacyApplication(),
    legacyApplication = _useLegacyApplication.legacyApplication;
  var displayedScore = useCurrentInsightScoreToDisplay();
  var _useIntakes = useIntakes(),
    academicIntakes = _useIntakes.academicIntakes,
    eslIntakes = _useIntakes.eslIntakes;
  var _useUpdateApplication = useUpdateApplication(),
    updateApplication = _useUpdateApplication.updateApplication,
    isUpdatingApplication = _useUpdateApplication.isUpdatingApplication;
  var toasts = useToasts();
  var formId = useId();
  var queryClient = useQueryClient();
  var _useApplicationAvaila = useApplicationAvailableActions(),
    canPerformApplicationAction = _useApplicationAvaila.canPerformApplicationAction;
  var academicProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Main;
  });
  var _useApplicationAvaila2 = useApplicationAvailableActions(),
    getApplicationAvailableAction = _useApplicationAvaila2.getApplicationAvailableAction;
  var changeIntakeActionInfo = (_getApplicationAvaila = getApplicationAvailableAction(ApplicationActionName.CHANGE_INTAKE)) === null || _getApplicationAvaila === void 0 ? void 0 : _getApplicationAvaila.additionalInformation;
  assert(academicProgram, 'Legacy application missing academic program');
  var initialAcademicIntake = academicProgram.intake.startDate || '';
  var eslProgram = legacyApplication.programs.find(function (program) {
    return program.programType === ProgramType.Esl;
  });
  var initialEslIntake = (eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate) || '';
  var selectableAcademicIntakes = academicIntakes.filter(function (intake) {
    return intake.programType === ProgramType.Main && ((changeIntakeActionInfo === null || changeIntakeActionInfo === void 0 ? void 0 : changeIntakeActionInfo.showAllIntakes) || isSelectableIntake(intake, initialAcademicIntake));
  });
  var selectableEslIntakes = eslIntakes.filter(function (intake) {
    return intake.programType === ProgramType.Esl && ((changeIntakeActionInfo === null || changeIntakeActionInfo === void 0 ? void 0 : changeIntakeActionInfo.showAllIntakes) || isSelectableIntake(intake, initialEslIntake));
  });
  var trackingData = {
    programId: academicProgram.programId,
    programLevel: academicProgram.levelText,
    schoolId: legacyApplication.school.id,
    schoolCountry: legacyApplication.school.countryCode,
    score: (displayedScore === null || displayedScore === void 0 ? void 0 : (_displayedScore$seatA = displayedScore.seatAvailability) === null || _displayedScore$seatA === void 0 ? void 0 : _displayedScore$seatA.score) || null,
    scoreLevel: (displayedScore === null || displayedScore === void 0 ? void 0 : (_displayedScore$seatA2 = displayedScore.seatAvailability) === null || _displayedScore$seatA2 === void 0 ? void 0 : _displayedScore$seatA2.determination) || null,
    currentAcademicIntake: initialAcademicIntake,
    currentESLIntake: eslProgram === null || eslProgram === void 0 ? void 0 : eslProgram.intake.startDate,
    origin: origin
  };
  var _useEventTracker = useEventTracker({
      data: trackingData
    }),
    trackEvent = _useEventTracker.trackEvent;
  if (!canPerformApplicationAction(ApplicationActionName.CHANGE_INTAKE)) {
    return null;
  }
  return _jsxs(Dialog, {
    open: _onOpenChange ? isOpenViaProp : isOpen,
    onOpenChange: function onOpenChange(openStatus) {
      if (_onOpenChange) {
        _onOpenChange(openStatus);
      } else {
        setIsModalOpen(openStatus);
      }
      if (!openStatus) {
        trackEvent({
          event: 'Single Application - Intake Change - Dismissed Modal By Clicking Away OR X',
          data: {
            otherAcademicIntakes: academicIntakes
          }
        });
      }
    },
    children: [hideDialogTrigger ? _jsx(_Fragment, {}) : _jsx(Dialog.Trigger, {
      children: _jsx(Button, {
        width: width,
        emphasis: "outlined",
        intent: buttonIntent,
        onClick: onClick,
        children: "Change intake"
      })
    }), _jsx(Dialog.Heading, {
      children: "Change Intake"
    }), _jsxs(Dialog.Content, {
      children: [_jsx(ChangeIntakeModalEventTracker, {
        eventTrackingData: _objectSpread(_objectSpread({}, trackingData), {}, {
          otherAcademicIntakes: selectableAcademicIntakes
        })
      }), _jsx(IntakesForm, {
        academicIntakes: selectableAcademicIntakes,
        eslIntakes: selectableEslIntakes,
        availableActions: {
          canUpdateEsl: !!(changeIntakeActionInfo !== null && changeIntakeActionInfo !== void 0 && changeIntakeActionInfo.eslIntakeUpdateAllowed),
          canUpdateStartDates: !!(changeIntakeActionInfo !== null && changeIntakeActionInfo !== void 0 && changeIntakeActionInfo.startDateUpdateAllowed)
        },
        id: formId,
        onSubmit: function onSubmit(values) {
          var selectedEslIntake = selectableEslIntakes.find(function (intake) {
            return intake.startDate === values.eslIntake;
          });
          var selectedAcademicIntake = selectableAcademicIntakes.find(function (intake) {
            return intake.startDate === values.academicIntake;
          });
          assert(selectedAcademicIntake, "Cannot find academic intake with start date ".concat(values.academicIntake));
          if (values.eslIntake) {
            assert(selectedEslIntake, "Cannot find ESL intake with start date ".concat(values.eslIntake));
          }
          updateApplication({
            programs: [{
              legacyIntakeId: "".concat(selectedAcademicIntake.intakeId),
              legacyProgramId: "".concat(academicProgram.programId),
              programType: 'main',
              actualStartDate: values.academicActualStartDate,
              alternateActualStartDate: values.academicAlternateActualStartDate || undefined
            }].concat(_toConsumableArray(values.eslIntake && eslProgram && selectedEslIntake ? [{
              legacyIntakeId: "".concat(selectedEslIntake.intakeId),
              legacyProgramId: "".concat(eslProgram.programId),
              programType: 'esl',
              actualStartDate: values.eslActualStartDate,
              alternateActualStartDate: values.eslAlternateActualStartDate
            }] : []))
          }, {
            onError: function onError(error) {
              if (error instanceof Error) {
                toasts.negative(error);
              } else {
                toasts.negative(new Error('Error while trying to change intakes'));
              }
            },
            onSuccess: function onSuccess() {
              _onSuccess === null || _onSuccess === void 0 ? void 0 : _onSuccess({
                academicIntake: values.academicIntake,
                academicIntakeId: Number(selectedAcademicIntake === null || selectedAcademicIntake === void 0 ? void 0 : selectedAcademicIntake.intakeId),
                eslIntake: values.eslIntake,
                eslIntakeId: Number(selectedEslIntake === null || selectedEslIntake === void 0 ? void 0 : selectedEslIntake.intakeId),
                program: academicProgram,
                programEsl: eslProgram
              });
              queryClient.invalidateQueries({
                queryKey: ['recommendedPrograms', {
                  pkg: 'ab-application'
                }]
              });
              toasts.positive('Successfully changed intakes');
              _onOpenChange ? _onOpenChange(false) : setIsModalOpen(false);
              trackEvent({
                event: 'Single Application - Intake Change - Clicked On Save',
                data: {
                  selectedEslIntake: values.eslIntake.length > 0 ? values.eslIntake : null,
                  selectedAcademicIntake: values.academicIntake,
                  otherAcademicIntakes: selectableAcademicIntakes
                }
              });
            }
          });
        },
        isUpdating: isUpdatingApplication,
        onEvent: function onEvent(event) {
          if (event === 'sortByDate' || event === 'sortBySuccessScore') {
            trackEvent({
              event: 'Single Application - Intake Change - Clicked Sort By',
              data: {
                sortBySelected: event === 'sortByDate' ? 'Intake' : 'Success score'
              }
            });
          }
        }
      })]
    }), _jsxs(Dialog.Actions, {
      children: [_jsx(Dialog.CloseButton, {
        width: "fill",
        children: "Cancel"
      }), _jsx(Button, {
        type: "submit",
        form: formId,
        intent: "primary",
        width: "fill",
        loading: isUpdatingApplication,
        children: "Save"
      })]
    })]
  });
}
function isSelectableIntake(intake, currentIntakeStartDate) {
  if (intake.startDate === currentIntakeStartDate) {
    return true;
  }
  return [IntakeStatus.OPEN, IntakeStatus.LIKELY_OPEN, IntakeStatus.WILL_OPEN, IntakeStatus.WILL_OPEN_CONDITIONALLY, IntakeStatus.WAITLIST].includes(intake.intakeStatus);
}
var ChangeIntakeModalEventTracker = function ChangeIntakeModalEventTracker(_ref2) {
  var eventTrackingData = _ref2.eventTrackingData;
  useTrackViewEvent({
    event: 'Single Application - Intake Change - Started',
    data: eventTrackingData
  });
  return _jsx(_Fragment, {});
};